"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeInitParams = void 0;
var _ethers = require("ethers");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const ethers = _objectSpread({}, _ethers.ethers);
if (ethers.version.includes("/5")) {
  ethers.AbiCoder = {
    defaultAbiCoder: () => ethers.utils.defaultAbiCoder
  };
}
const encodeInitParams = ({
  name,
  symbol,
  deployer
}) => {
  return ethers.AbiCoder.defaultAbiCoder().encode(["string", "string", "address"], [name, symbol, deployer]);
};
exports.encodeInitParams = encodeInitParams;